module.exports = __webpack_public_path__ + "img/inactive-10.1cb5811b.svg";